import { apiRequest } from '@/lib/api-client';

type ContactMessage = {
  id: string;
  name: string;
  email: string;
  phone: string | null;
  subject: string | null;
  message: string;
  created_at: string;
};

type NewContactMessage = Omit<ContactMessage, 'id' | 'created_at'> & {
  captcha?: string;
  captchaSum?: number;
};

export async function getAllContactMessages(): Promise<ContactMessage[]> {
  return apiRequest<ContactMessage[]>('/contact/index.php');
}

export async function getContactMessageById(id: string): Promise<ContactMessage | null> {
  try {
    return await apiRequest<ContactMessage>(`/contact/${id}`);
  } catch (error) {
    return null;
  }
}

export async function createContactMessage(message: NewContactMessage): Promise<void> {
  await apiRequest('/contact/send.php', {
    method: 'POST',
    body: JSON.stringify(message),
  });
}

export async function deleteContactMessage(id: string): Promise<void> {
  await apiRequest(`/contact/${id}`, {
    method: 'DELETE',
  });
}

export async function addContactMessage(message: NewContactMessage): Promise<void> {
  return createContactMessage(message);
}
